export default {
  setLoading (state, loading) {
    state.loading = loading
  },
  setSaving (state, saving) {
    state.saving = saving
  }
}
